import { SlotGame } from '@nolimitcity/slot-game/bin/SlotGame';
import { Beheaded } from '../../Beheaded';
import { BeheadedEngineManager } from '../../reels/BeheadedEngineManager';
import { GameData } from '../../server/data/GameData';
import { InitData } from '../../server/data/InitData';
import { IntroPresentation } from '../IntroPresentation';
import { AvalancheStartPresentation, StartStates } from '../reel/general/AvalancheStartPresentation';
// import { StopPresentation } from '../reel/general/StopPresentation';

export class RestorePresentation extends AvalancheStartPresentation {

    private init:InitData;
    private restored:boolean = false;

    public checkForActivation(data: GameData | InitData): boolean {
        return data.isRestoreState;
    }

    public setInitData(data: InitData): void {
        this.setGamedData(data);
        this.init = data;
    }

    public setGamedData(data: GameData | InitData): void {
        super.setGamedData(data);
        this.init = data as InitData;
        BeheadedEngineManager.RAll((reel) => {
            reel.setCutIndicator(data.raw.cutIndex[reel.reelID]);
        });
    }

    createPresentation(): void {

        if(this.restored){
            if(this.init.isNextAvalanche)
                super.createPresentation();
            else{
                if(this.init.isNormalMode && this.init.nextMode === "SUPER_FREESPIN"){
                    this.onSfsIntro();
                }
                this.PresentationState.setInactive()
            }
        }

        if(!this.restored){
            
            let currentLevel: number = this.init.isNextAvalanche ? this.init.currentLevel : this.init.nextLevel;
            // if(this.init.mode === "SUPER_FREESPIN_END") currentLevel = 5;

            this.timeline.add(Beheaded.souldWildController.isRestore(
                this.init.collectedSouls,
                currentLevel,
                this.init.Reel.SWBoolMap,
                !!this.init.Reel.SWSize
            ));

            const ammSyms:number = this.init.collectedSymbols + (this.init.willUpgrade ? Beheaded.collectorBar.lvlTresholds[currentLevel] : 0)
            Beheaded.collectorBar.setLevel(currentLevel,true);
            Beheaded.collectorBar.setValue(ammSyms,currentLevel);

            Beheaded.baseMultiplier.setValue(this.init.isNextAvalanche ? this.init.nextWinMultiplier : this.init.currentWinMultiplier);

            Beheaded.overlayBG.upgradeBGOverlay(currentLevel);

            Beheaded.background.upgradeBG(currentLevel); /// 5,4,3,2,1  || 0,1,2,3,4,5
            if(currentLevel){
                BeheadedEngineManager.RSAll((r,sym) => {
                    if([5,4,3,2,1][currentLevel-1] <= parseInt(sym.symName[1]) )
                        sym.chargeSymbol()
                })
            }
            Beheaded.overlayBG.flagShow(currentLevel !== 5);

            const fsAmm = this.init.freespinsLeft - (this.init.raw.addedNumberOfFreespinsThisSpin - this.init.Reel.ammScatterCaught);
            if(currentLevel !== 5)
                SlotGame.keypadPlugin.setZeroBetSpinCounter(fsAmm ? fsAmm : -1);

            this.timeline.to(this,{duration:0.2});
            this.restored = true;
        }

       
    }
}
